import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { Permission } from "@/api/permissions";
import type { Whoami } from "@/api/types";

export const whoamiQueryKey = ["whoami"] as const;

/**
 * The single source of truth for identity + permission-driven rendering.
 * Loaded once per session; <Can>, the nav, and route guards all read it.
 */
export const useWhoami = () =>
  useQuery({
    queryKey: whoamiQueryKey,
    queryFn: () => api.get<Whoami>("/admin/whoami"),
    staleTime: Infinity,
    retry: false,
  });

export const useHasPermission = (): ((permission: Permission) => boolean) => {
  const { data } = useWhoami();
  return (permission) => data?.permissions.includes(permission) ?? false;
};
